module.exports = __webpack_public_path__ + "img/cardinal_logo_white.5729c4d0.png";